module.exports = __webpack_public_path__ + "static/media/shortly.45f63772.svg";